<template>
  <div class="transfer-note page page-with-table p-2">
    <page-header class="mb-2" :title="$t('Transfer Notes')">
      <template v-slot:buttons>
        <add-new-button v-permission="'change_transfernote'" @click="onNewClick">
          <font-awesome-icon icon="plus-circle" class="icon"/>
          {{$t('New Transfer Note')}}
        </add-new-button>
      </template>
    </page-header>
    <div class="card content-wrapper p-2">
      <transfer-note-table/>
    </div>
  </div>
</template>

<script>
  import AddNewButton from "../../core/components/common/AddNewButton";
  import {createNamespacedHelpers} from "vuex";
  import PageHeader from "../../core/components/page-header/PageHeader";
  import TransferNoteTable from "@/modules/transfer-notes/TransferNoteTable";
  import {SOURCE_TRANSFER_NOTES_TABLE} from "@/modules/constants";

  const {mapActions} = createNamespacedHelpers('transferNotes');
  export default {
    name: "TransferNote",
    components: {TransferNoteTable, PageHeader, AddNewButton},
    methods: {
      ...mapActions(['showModal', 'updateTableSource', 'hideModal']),
      onNewClick() {
        this.showModal({source: SOURCE_TRANSFER_NOTES_TABLE})
      }
    },
    async beforeMount() {
      await this.updateTableSource({source: 'transferNote'});
    },
    async beforeRouteLeave(to, from, next) {
      this.hideModal()
      return next()
    },
  }
</script>

<style lang="scss" scoped>
</style>

